<template>
  <div class="container">
    <individueel v-for="item in leiding" :key="item.id" :leiding="item"> </individueel>
  </div>
</template>

<script>
import Individueel from '@/components/leiding/Individueel.vue';

export default {
  name: 'leiding',
  components: { individueel: Individueel },
  data: () => ({
    leiding: [
      {
        id: 1,
        naam: 'Jelle',
        titel: 'Hoofdleider',
        slagzin: 'Neem het van mij aan: muren zijn hard.',
      },
      {
        id: 2,
        naam: 'Naomi',
        titel: 'Kleine Peper',
        slagzin: 'Wist je dat er in paprikachips meer zout zit dan in zoutchips?',
      },
      {
        id: 3,
        naam: 'Diede',
        titel: 'Kleine Peper',
        slagzin: 'Wist je dat mensen na gemiddeld\xa04\xa0seconden een stilte gênant vinden…?',
      },
      {
        id: 4,
        naam: 'Evelien',
        titel: 'Kleine Peper',
        slagzin: 'Ik doe mijn best, maar God doet de rest!',
      },
      {
        id: 5,
        naam: 'Johan',
        titel: 'Kleine Peper',
        slagzin: 'Doe mij maar een kebab cocktail met extra pepers.',
      },
      {
        id: 6,
        naam: 'Eline',
        titel: 'Kleine Peper',
        slagzin: 'Rozen zijn rood, mijn haar is dat ook, ik heb schoenmaat\xa041 ~ Albert Einstein',
      },
      {
        id: 7,
        naam: 'Eliza',
        titel: 'Kleine Peper',
        slagzin: 'Er is altijd wel een reden om te lachen.',
      },
      {
        id: 8,
        naam: 'Martijn',
        titel: "Let's Talk About",
        slagzin: 'Een beetje chaos doet wonderen.',
      },
      {
        id: 9,
        naam: 'Goele',
        titel: 'Grote Peper',
        slagzin: 'voor een goeie mop zitten we in een indianendorp.',
      },
      {
        id: 10,
        naam: 'Sil',
        titel: 'Grote Peper',
        slagzin: 'Ik heb nog zin in een kroket, ... Of 70!',
      },
      {
        id: 11,
        naam: 'Tom',
        titel: 'Studie',
        // slagzin: 'het hoeft niet lekker te zijn, als het maar veel is',
      },
    ],
  }),
};
</script>
